import { createRedirectToContactUs } from '../utils/patientRecordUtils';

export const getPatientDeceasedConfig = (
  headingDetails,
  patientTitle,
  labels,
  country,
  lang,
) => {
  const redirectToContactUs = createRedirectToContactUs(
    country,
    lang,
  );
  return {
    ...headingDetails,
    title: {
      ...headingDetails.title,
      content: patientTitle,
    },
    buttonConfig: null,
    alertConfig: {
      ...headingDetails.alertConfig,
      visible: true,
      dismissible: false,
      type: 'info',
      title: `${labels['labels.patientRecord.heading.alert.title.deceased']}`,
      message: `${labels['labels.patientRecord.heading.alert.message.deceased']}`,
      actions: [
        {
          text: `${labels['labels.patientRecord.heading.alert.button.deceased']}`,
          onClick: redirectToContactUs,
        },
      ],
    },
    errorConfig: {
      isDeceased: true,
      errorView: {
        layout: 'horizontal',
        imgAlt: 'labels.patientRecord.deceased.errorMessage.imgAlt',
        imgSrc:
          'https://mss-p-007-delivery.stylelabs.cloud/api/public/content/CDS_Pictogram_Password?v=e6c2d773',
        imgWidth: '116',
        title: 'labels.patientRecord.deceased.errorMessage.title',
        text: 'labels.patientRecord.deceased.errorMessage.text',
        buttons: [
          {
            name: 'dpxContactUs',
            variant: 'brand-primary',
            text: `${labels['labels.patientRecord.deceased.errorMessage.button']}`,
            icon: '',
            link: '',
            action: 'link-dpx-login',
            useCallback: true,
          },
        ],
        handleCallback: redirectToContactUs,
      },
      labels,
    },
  };
};

export const getNotiAlertConfig = (visible, message) => ({
  visible,
  message,
  type: 'success',
  dismissible: true,
});

export const genericEmptyListElementsConfig = [
  {
    id: 'emptyList',
    label: '',
    value: '{{emptyText}}',
    validators: [],
  },
];

export const genericErrorElementsConfig = [
  {
    id: 'errorTitle',
    label: '',
    value: '<span class="ccl__text--body-text-bold">{{title}}</span>',
    validators: [],
  },
  {
    id: 'errorBody',
    label: '',
    value: '{{line1}} {{line2}}',
    validators: [],
  },
];
